<template>
  <v-select
    v-bind="[fieldProps, $attrs]"
    :loading="loading"
    :items="items"
    v-model="model"
    name="cidade"
    placeholder="Cidade"
    :menu-props="menuProps"
    clearable
  >
  </v-select>
</template>

<script>
import { mixin } from "./mixin";

const _config = {
  mod: "cities",
};

const _data = {
  loading: true,
  model: null,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    menuProps() {
      const height = window.innerHeight / 2 - 24;

      return {
        maxHeight: height,
        closeOnContentClick: true,
      };
    },
    query() {
      return this.$route.query;
    },
    business() {
      switch (this.$route.path) {
        case "/imoveis":
          return "Venda";
        case "/locacao":
          return "Aluguel";
        default:
          return null;
      }
    },
    category() {
      const category = this.query.tipo;

      if (category) return category;

      switch (this.$route.path) {
        case "/terrenos":
          return "Terreno,Terreno Comercial";
        case "/rural":
          return "Área,Chácara,Fazenda,Sítio";
        default:
          return "";
      }
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {};

      if (this.business) params.business = this.business;
      if (this.category) params.category = this.category;

      this.$rest(_config.mod)
        .get({ params })
        .then(() => {
          this.model = this.$route.query.cidade
            ? this.$route.query.cidade
            : null;
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
    model(v) {
      if (v !== this.$route.query.cidade) {
        let path = this.$route.path;
        const parameters = [];

        if (null !== v) {
          parameters.push("cidade=" + v);

          path += "?" + parameters.join("&");
        }
        this.$router.push({ path });
      }
    },
  },
  mounted() {
    if (this.$route.query.cidade) this.model = this.$route.query.cidade;
  },
  created() {
    this.getList();
  },
  mixins: [mixin],
};
</script>
